import React, { useEffect, useState } from "react";
import {
  Grid,
  Tooltip,
  Card,
} from "@mui/material";
import {
  Info as InfoIcon,
  Store as StoreIcon,
  PhotoLibrary as PhotoLibraryIcon,
  Description as DescriptionIcon,
  LocationOn as LocationOnIcon,
  AccessTime as AccessTimeIcon,
  Star as StarIcon,
  ArrowCircleRightOutlined,
} from "@mui/icons-material";
import GeneralInformation from "./components/General";
import SimpleForm from "./components/MerchantSetting";
import ImageGallery from "./components/GalleryImage";
import HoursOfOperation from "./components/OperationHours";
import AdditionalLocation from "./components/Address";
import TermsAndConditions from "./components/Terms&Condition";
import HighlightsComponent from "./components/Highlights";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import { baseURL } from "utils/api";
import AccountCircleIcon from '@mui/icons-material/Preview';
import Profile from "./components/profile";
import { Link, useParams } from "react-router-dom";
import HappyHours from "./components/HappyHours";
import useMediaQuery from '@mui/material/useMediaQuery';
import DummyImage from "assets/images/2665820.jpg";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";


const BusinessForm = () => {

  const matches = useMediaQuery('(max-width:600px)');
  const [logo1, setLogo1] = useState(null);
  const { id } = useParams()
  const [activeSection, setActiveSection] = useState("Preview");
  const adminId = localStorage.getItem("id");
  const [refresh, setRefresh] = useState(0)
  const [profileFile, setProfileFile] = useState(null);
  const [businessDetail, setBusinessDetail] = useState({});

  const userTheme = useSelector((state) => state.commonSlice.theme);

  const handleLogoUpload = (event, setLogo) => {
    const file = event.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setLogo(fileURL);
      setProfileFile(file);
    };

    const formData = new FormData();
    formData.append("businessLogo", file);
    fetch(`${baseURL}updateBusiness/${businessDetail?._id}`, {
      method: "PUT",
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((resp) => {
        if (resp.success) {
          toast.success("Logo updated successfully");
          // window.location.reload();
        }
      });
  };

  const triggerFileUpload = (inputId) => {
    document.getElementById(inputId).click();
  };

  const handleSectionClick = (section) => {
    setActiveSection(section);
  };


  const [sections, setSections] = useState([
    { label: "Preview", icon: AccountCircleIcon },
    { label: "General Information", icon: InfoIcon },
    { label: "Merchant Settings", icon: StoreIcon },
    { label: "Image Gallery", icon: PhotoLibraryIcon },
    { label: "Hours Of Operation", icon: AccessTimeIcon },
    { label: "Terms and Conditions", icon: DescriptionIcon },
    { label: "Highlights", icon: StarIcon },
  ])



  const fetchBusinessDetail = async () => {
    fetch(`${baseURL}businessDetails/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json())
      .then((resp) => {
        console.log(resp, "business detail");
        if (resp.success) {
          setBusinessDetail(resp.data);

          if (resp.data?.category?.name == 'Dining & Drinks') {
            setSections([
              { label: "Preview", icon: AccountCircleIcon },
              { label: "General Information", icon: InfoIcon },
              { label: "Merchant Settings", icon: StoreIcon },
              { label: "Image Gallery", icon: PhotoLibraryIcon },
              { label: "Hours Of Operation", icon: AccessTimeIcon },
              { label: "Terms and Conditions", icon: DescriptionIcon },
              { label: "Highlights", icon: StarIcon },
              { label: "Happy Hours Config", icon: AccessTimeIcon }
            ])
          }
        }
      });
  };

  useEffect(() => {
    fetchBusinessDetail()
  }, [refresh]);


  const handelRefresh = () => {
    setRefresh(refresh + 1)
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid mt={3} container spacing={3}>
        {/* Sidebar */}
        <Grid item xs={12} sm={3} sx={{ position: matches ? 'static' : 'sticky', top: 0, height: 'fit-content' }}>
          <Card className="glassmorphism-card" elevation={3} style={{ padding: 20, textAlign: "center" }}>
            <SoftBox style={{ position: "relative", display: "inline-block" }}>
              <SoftBox
                variant="outlined"
                color="info"
                style={{ position: "absolute", top: -13, left: -10, cursor: "pointer" }}
              >
                <Link to="/business-Profile">
                  <ArrowCircleRightOutlined
                    style={{ transform: "rotate(180deg)", color: userTheme == 'dark' ? "#ffffff" : "#141414" }}
                  />
                </Link>
              </SoftBox>

              <SoftBox>
                <Tooltip title="Edit Logo">

                  <img
                    src={logo1 != null ? logo1 : (businessDetail?.businessLogo && businessDetail?.businessLogo != '' ? businessDetail?.businessLogo : DummyImage)}
                    alt="Restaurant Logo 1"
                    onClick={() => triggerFileUpload("logo-upload-1")}
                    style={{ width: "100%", maxWidth: 100, height: 100, borderRadius: "50%", border: "1px solid #ccc", cursor: "pointer" }}
                  />
                </Tooltip>
              </SoftBox>

              <input
                id="logo-upload-1"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => handleLogoUpload(e, setLogo1)}
              />
            </SoftBox>
            <SoftTypography
              variant="h5"
              gutterBottom
              style={{
                fontWeight: "bold",
              }}
            >
              <span style={{ fontSize: "14px", color: "gray" }}>{businessDetail?.locationName}</span>
              <br />
              {businessDetail?.businessName}
            </SoftTypography>
          </Card>
          <SoftBox
            mt={3}
            sx={{
              background: '#f9fafb',
              borderRadius: '18px',
              boxShadow: '0 2px 12px 0 rgba(31, 38, 135, 0.06)',
              border: '1px solid #f0f1f3',
              padding: 2.5,
              textAlign: 'left',
              minWidth: 220,
              maxWidth: 320,
              mx: 'auto',
            }}
            className="glassmorphism-card"
          >
            {sections.map(({ label, icon: Icon }, index) => {
              const isActive = activeSection === label;
              return (
                <SoftTypography
                  key={label}
                  variant="h6"
                  gutterBottom
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    cursor: 'pointer',
                    fontWeight: isActive ? 600 : 400,
                    fontSize: '1rem',
                    background: isActive ? '#eaf1fb' : 'none',
                    boxShadow: 'none',
                    px: 1.5,
                    py: 1.2,
                    borderRadius: '6px',
                    mb: 0.5,
                    transition: 'background 0.2s, color 0.2s',
                    color: !isActive ? '#5c6f8c' : undefined,
                  }}
                  onClick={() => handleSectionClick(label)}
                >
                  <Icon
                    style={{
                      fontSize: '2rem',
                      color: isActive ? 'rgb(143, 41, 185)' : '#b0b8c9',
                      marginRight: 12,
                    }}
                  />
                  {isActive ? (
                    <span
                      style={{
                        background: 'linear-gradient(90deg, rgb(143, 41, 185), rgb(33, 212, 253))',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        fontWeight: 600,
                        display: 'inline-block',
                      }}
                    >
                      {label}
                    </span>
                  ) : (
                    label
                  )}
                </SoftTypography>
              );
            })}
          </SoftBox>

        </Grid>

        <Grid item xs={12} sm={9}>
          {activeSection === "Preview" && <Profile data={businessDetail} />}
          {activeSection === "General Information" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><GeneralInformation data={businessDetail} profile={profileFile} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Merchant Settings" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><SimpleForm data={businessDetail} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Image Gallery" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><ImageGallery refresh={refresh} data={businessDetail?.images} id={businessDetail?._id} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Hours Of Operation" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><HoursOfOperation data={businessDetail?.operatingHours} id={businessDetail?._id} /></Card>}
          {activeSection === "Happy Hours Config" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><HappyHours id={businessDetail?._id} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Terms and Conditions" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><TermsAndConditions data={businessDetail?.termsAndConditions} id={businessDetail?._id} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Highlights" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><HighlightsComponent email={businessDetail?.email} id={businessDetail?._id} userId={businessDetail?.userId} /></Card>}
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default BusinessForm;










